import { useEffect, useState } from 'react';
import { logError } from '@pegasus/sentry';
import { getRecommendations } from '../request';
import { CustomerGender } from '../types';
export var useFetchRecommendations = function (gender) {
    if (gender === void 0) { gender = CustomerGender.FEMALE; }
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState([]), recommendations = _b[0], setRecommendations = _b[1];
    useEffect(function () {
        if (!loading && !recommendations.length) {
            setLoading(true);
            getRecommendations(gender)
                .then(function (newRecommendations) { return setRecommendations(newRecommendations || []); })
                .catch(function () {
                var error = new Error("Error on getting recomendations with gender = ".concat(gender));
                logError("useFetchRecommendations - Request failed", { error: error });
                setRecommendations([]);
            })
                .finally(function () { return setLoading(false); });
        }
    }, []);
    return [recommendations, loading];
};
